import { Module } from 'vuex';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';

const layout: Module<LayoutTitle, any> = {
    namespaced: true,
    state: {
        route: [],
        title: '',
    },
    mutations: {
        [LayoutMutations.CHANGE_TITLE](state, title: LayoutTitle): void {
            state.route = title.route;
            state.title = title.title;
        },
    },
    actions: {},
};

export default layout;
